<script>
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';
export default {
  name: 'TermsPoliticsPageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
  data() {
    return {
      activeSection: 'terminos',
    };
  },
  methods: {
    setSection(section) {
      this.activeSection = section;
    },
  },
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="public-hero">
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >Términos y Políticas</a>
        </nav>
        <h1 class="public-hero__title">Términos y Condiciones</h1>
        <p class="public-hero__subtitle">Última actualización: Agosto 2024. Conoce los términos que rigen el uso de nuestra plataforma.</p>
      </div>
    </section>

    <!-- Body -->
    <main class="public-body">
      <div class="row">
        <!-- Sidebar -->
        <div class="col-lg-3 col-md-4 mb-24">
          <ul class="public-sidebar__list">
            <li>
              <a
                href="#"
                :class="{ active: activeSection === 'terminos' }"
                @click.prevent="setSection('terminos')"
              >
                <i class="uil uil-file-alt" /> Términos de Uso
              </a>
            </li>
            <li>
              <a
                href="#"
                :class="{ active: activeSection === 'privacidad' }"
                @click.prevent="setSection('privacidad')"
              >
                <i class="uil uil-shield" /> Políticas de Privacidad
              </a>
            </li>
            <li>
              <a
                href="#"
                :class="{ active: activeSection === 'autor' }"
                @click.prevent="setSection('autor')"
              >
                <i class="uil uil-copyright" /> Derechos de Autor
              </a>
            </li>
            <li>
              <a
                href="#"
                :class="{ active: activeSection === 'cookies' }"
                @click.prevent="setSection('cookies')"
              >
                <i class="uil uil-clipboard-alt" /> Políticas de Cookies
              </a>
            </li>
            <li>
              <a
                href="#"
                :class="{ active: activeSection === 'asesor' }"
                @click.prevent="setSection('asesor')"
              >
                <i class="uil uil-book-open" /> Términos de Asesor
              </a>
            </li>
            <li>
              <a
                href="#"
                :class="{ active: activeSection === 'precios' }"
                @click.prevent="setSection('precios')"
              >
                <i class="uil uil-dollar-alt" /> Precios e Incrementos
              </a>
            </li>
          </ul>
        </div>

        <!-- Content -->
        <div class="col-lg-9 col-md-8">
          <!-- Términos de Uso -->
          <div
            v-if="activeSection === 'terminos'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <p class="public-card__meta">Última actualización: Agosto 2024</p>
            <h3>1. Aceptación de los Términos</h3>
            <p>
              Al acceder y utilizar la plataforma AppMisionate, usted acepta estar sujeto a los
              presentes Términos y Condiciones. Si no está de acuerdo con alguno de estos términos,
              le solicitamos no utilizar nuestros servicios.
            </p>
            <div class="public-card__divider" />
            <h3>2. Cuentas de Usuario</h3>
            <p>
              Para acceder a ciertos servicios, deberá crear una cuenta. Usted es responsable de
              mantener la confidencialidad de su contraseña y de todas las actividades realizadas bajo
              su cuenta. AppMisionate no se hace responsable por accesos no autorizados derivados
              del descuido del usuario.
            </p>
            <p>
              Usted acepta proporcionar información veraz y actualizada. Nos reservamos el derecho
              de suspender o eliminar cuentas que incumplan estos términos.
            </p>
            <div class="public-card__divider" />
            <h3>3. Pagos y Devoluciones</h3>
            <p>
              Los precios de nuestros cursos y simuladores están sujetos a cambios sin previo aviso.
              Los pagos se procesan a través de pasarelas de pago seguras. Las solicitudes de
              devolución se evaluarán caso por caso dentro de los primeros 7 días posteriores a la
              compra, siempre que el usuario no haya avanzado más del 20% del contenido.
            </p>
            <div class="public-card__divider" />
            <h3>4. Contenido y Comportamiento</h3>
            <p>
              Usted se compromete a utilizar la plataforma de manera lawful y respetuosa. Queda
              prohibido compartir contenido obsceno, difamatorio, violento o que infrinja derechos
              de terceros. El incumplimiento de esta cláusula resultará en la cancelación inmediata
              de su cuenta.
            </p>
            <div class="public-card__divider" />
            <h3>5. Propiedad Intelectual</h3>
            <p>
              Todo el contenido de AppMisionate, incluyendo textos, gráficos, logotipos, imágenes,
              simuladores y material de курс, es propiedad de AppMisionate o sus licenciantes y
              está protegido por las leyes de propiedad intelectual.
            </p>
            <div class="public-card__divider" />
            <h3>6. Contacto</h3>
            <p>
              Para cualquier duda sobre estos términos, puede contactarnos a través de nuestra
              página de <router-link to="/contacto">contacto</router-link> o al correo
              <strong>hola@appmisionate.com</strong>.
            </p>
          </div>

          <!-- Políticas de Privacidad -->
          <div
            v-if="activeSection === 'privacidad'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <p class="public-card__meta">Última actualización: Agosto 2024</p>
            <h3>Política de Privacidad</h3>
            <p>
              En AppMisionate respetamos su privacidad y nos comprometemos a proteger sus datos
              personales. Esta política describe qué información recopilamos, cómo la usamos
              y las medidas que tomamos para protegerla.
            </p>
            <div class="public-card__divider" />
            <h4>Información que recopilamos</h4>
            <ul>
              <li>Nombre completo y datos de contacto al registrarse</li>
              <li>Correo electrónico y contraseña (encriptada)</li>
              <li>Datos de progreso en cursos y simuladores</li>
              <li>Información de pago procesada por pasarelas externas</li>
              <li>Datos de navegación y preferencias de uso</li>
            </ul>
            <div class="public-card__divider" />
            <h4>Uso de la información</h4>
            <ul>
              <li>Brindar y mejorar nuestros servicios educativos</li>
              <li>Enviar notificaciones sobre su progreso y nuevas funciones</li>
              <li>Procesar pagos y gestionar suscripciones</li>
              <li>Cumplir con obligaciones legales aplicables</li>
            </ul>
            <div class="public-card__divider" />
            <h4>Sus derechos</h4>
            <p>
              Usted puede ejercer sus derechos ARCO (Acceso, Rectificación, Cancelación y
              Oposición) enviando un correo a <strong>privacidad@appmisionate.com</strong>.
              Responderemos su solicitud en un plazo máximo de 15 días hábiles.
            </p>
          </div>

          <!-- Derechos de Autor -->
          <div
            v-if="activeSection === 'autor'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <p class="public-card__meta">Última actualización: Agosto 2024</p>
            <h3>Derechos de Autor</h3>
            <p>
              Todo el contenido publicado en la plataforma AppMisionate, incluyendo pero no
              limitado a textos, imágenes, videos, simuladores, evaluaciones y material
              gráfico, está protegido por la Ley Federal del Derecho de Autor y tratados
              internacionales aplicables.
            </p>
            <div class="public-card__divider" />
            <h4>Uso permitido</h4>
            <ul>
              <li>Visualizar el contenido para fines educativos personales</li>
              <li>Descargar materiales marcados como descargables para uso propio</li>
              <li>Comentar o reseñar cursos (respetando las normas de conducta)</li>
            </ul>
            <div class="public-card__divider" />
            <h4>Uso prohibido</h4>
            <ul>
              <li>Reproducir, distribuir o comunicar públicamente el contenido sin autorización</li>
              <li>Utilizar el contenido para fines comerciales sin consentimiento</li>
              <li>Realizar ingeniería inversa de los simuladores o evaluaciones</li>
              <li>Eliminar o modificar marcas de derechos de autor</li>
            </ul>
          </div>

          <!-- Políticas de Cookies -->
          <div
            v-if="activeSection === 'cookies'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <p class="public-card__meta">Última actualización: Agosto 2024</p>
            <h3>Política de Cookies</h3>
            <p>
              Utilizamos cookies y tecnologías similares para mejorar su experiencia en
              AppMisionate, recordar sus preferencias y analizar el uso de nuestra plataforma.
            </p>
            <div class="public-card__divider" />
            <h4>Tipos de cookies que utilizamos</h4>
            <ul>
              <li><strong>Esenciales:</strong> Necesarias para el funcionamiento de la plataforma (sesión, autenticación)</li>
              <li><strong>De rendimiento:</strong> Nos ayudan a entender cómo los usuarios interactúan con la plataforma</li>
              <li><strong>De funcionalidad:</strong> Recuerdan sus preferencias y configuración</li>
              <li><strong>De analítica:</strong> Herramientas como Google Analytics para medir el tráfico</li>
            </ul>
            <div class="public-card__divider" />
            <h4>Gestión de cookies</h4>
            <p>
              Puede configurar su navegador para bloquear o eliminar cookies. Tenga en cuenta que
              algunas funcionalidades de la plataforma podrían verse afectadas si desactiva las
              cookies esenciales.
            </p>
          </div>

          <!-- Términos de Asesor -->
          <div
            v-if="activeSection === 'asesor'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <p class="public-card__meta">Última actualización: Agosto 2024</p>
            <h3>Términos para Asesores Educativos</h3>
            <p>
              Los asesores educativos que publican contenido en AppMisionate aceptan los siguientes
              términos adicionales a los Términos de Uso generales.
            </p>
            <div class="public-card__divider" />
            <h4>Responsabilidades del Asesor</h4>
            <ul>
              <li>Garantizar que el contenido publicado es de su autoría o cuenta con las licencias correspondientes</li>
              <li>Mantener actualizado el temario y los materiales educativos</li>
              <li>Responder a las dudas de los estudiantes en un plazo máximo de 48 horas hábiles</li>
              <li>Cumplir con los estándares de calidad establecidos por AppMisionate</li>
            </ul>
            <div class="public-card__divider" />
            <h4>Remuneración</h4>
            <p>
              La remuneración de los asesores se detalla en el Acuerdo de Collaboración específico
              que se firma al incorporarse como asesor. Los pagos se realizan conforme al calendario
              de liquidación vigente.
            </p>
          </div>

          <!-- Precios e Incrementos -->
          <div
            v-if="activeSection === 'precios'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <p class="public-card__meta">Última actualización: Agosto 2024</p>
            <h3>Precios e Incrementos</h3>
            <p>
              Nos esforzamos por mantener precios accesibles. Sin embargo, nos reservamos el
              derecho de ajustar nuestros planes y tarifas ante cambios significativos en
              costos operativos, inflación o mejoras sustanciales en el servicio.
            </p>
            <div class="public-card__divider" />
            <h4>Notificación de cambios</h4>
            <p>
              Cualquier incremento en los precios será comunicado con al menos <strong>30 días de
              anticipación</strong> a través del correo electrónico registrado y un aviso dentro
              de la plataforma. Los usuarios con suscripción activa mantendrán su precio
              vigente hasta el próximo ciclo de facturación.
            </p>
            <div class="public-card__divider" />
            <h4>Métodos de pago</h4>
            <ul>
              <li>Tarjeta de crédito y débito (Visa, Mastercard, AMEX)</li>
              <li>PayPal</li>
              <li>Transferencia bancaria (solo para suscripciones anuales)</li>
              <li>Cupones de descuento emitidos por AppMisionate o nuestros socios</li>
            </ul>
          </div>
        </div>
      </div>
    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.mb-24 {
  margin-bottom: 24px;
}
</style>
